import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-向右",
  "use": "icon-向右-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-向右\">\r\n<style type=\"text/css\">\r\n</style>\r\n<path class=\"st0\" d=\"M200,100L0,200L42.9,98.3L0,0L200,100z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol